export const tvColors = {
  opacity0: "rgb(245 124 0 / 0%)",
  orange: "#f57f17",
  purple: "#874F9F",
  gray: "#898989",
  blue: "#007bff",
  green: "#40bf6a",
  red: "#df2040",
};
